import { KRAV_VARDAG, KRAV_HELG } from './constants'

// Räkna ut arbetstimmar för ett pass (med hänsyn till lunchrast)
export function raknaArbetstimmar(passtyp) {
  if (!passtyp) return 0
  if (passtyp.ar_x_dag) return passtyp.x_dag_timmar || 0
  const start = tidTillMinuter(passtyp.starttid)
  let slut = tidTillMinuter(passtyp.sluttid)
  if (slut < start) slut += 24 * 60 // nattpas som går över midnatt
  const totalt = (slut - start) / 60
  return passtyp.har_lunchrast ? totalt - (passtyp.lunchlangd_min / 60) : totalt
}

function tidTillMinuter(tid) {
  const [h, m] = tid.split(':').map(Number)
  return h * 60 + m
}

// Räkna ut X-dag justering när ett pass ändras
export function raknaXDagJustering(gammaltPass, nyttPass) {
  const gammalt = raknaArbetstimmar(gammaltPass)
  const nytt = raknaArbetstimmar(nyttPass)
  return nytt - gammalt // positivt = fler timmar, negativt = färre
}

// Räkna total arbetstid för en medarbetare under en period
export function raknaTotalTid(pass) {
  return pass.reduce((sum, p) => sum + (p.arbetstimmar || 0), 0)
}

// Kontrollera bemanning för en dag
export function kontrolleraBemanning(passDagen, arHelg) {
  const krav = arHelg ? KRAV_HELG : KRAV_VARDAG
  const counts = { 'F/F1': 0, 'D1': 0, 'E/D2': 0, 'N': 0 }

  passDagen.forEach(p => {
    const namn = (p.passtyp_namn || '').toUpperCase()
    if (namn === 'F' || namn === 'F1') counts['F/F1']++
    else if (namn === 'D1') counts['D1']++
    else if (namn === 'E' || namn === 'D2') counts['E/D2']++
    else if (namn === 'N') counts['N']++
  })

  return krav.map(k => ({
    ...k,
    har: counts[k.key] || 0,
    ok: (counts[k.key] || 0) >= k.need,
    delvis: (counts[k.key] || 0) > 0 && (counts[k.key] || 0) < k.need,
  }))
}

// Kontrollera dygnsvila (11 timmar mellan pass)
export function kontrolleraDygnsvila(pass, medarbetareId) {
  const minaPass = pass
    .filter(p => p.medarbetare_id === medarbetareId)
    .sort((a, b) => new Date(a.datum) - new Date(b.datum))

  const problem = []
  for (let i = 1; i < minaPass.length; i++) {
    const prev = minaPass[i - 1]
    const curr = minaPass[i]
    if (!prev.passtyp || !curr.passtyp) continue

    const prevSlut = new Date(`${prev.datum}T${prev.passtyp.sluttid}`)
    const currStart = new Date(`${curr.datum}T${curr.passtyp.starttid}`)

    // Justera för nattpas
    if (prevSlut > currStart) prevSlut.setDate(prevSlut.getDate() + 1)

    const vilaTid = (currStart - prevSlut) / (1000 * 60 * 60)
    if (vilaTid < 11) {
      problem.push({
        datum: curr.datum,
        vilaTimmar: vilaTid,
        meddelande: `Endast ${vilaTid.toFixed(1)}h vila innan ${curr.passtyp_namn} ${curr.datum}`
      })
    }
  }
  return problem
}

// Beräkna om X-dag behöver justeras
export function beraknaXDagJustering(pass, totalKravTimmar) {
  const ordinarieTid = pass
    .filter(p => !p.ar_x_dag && p.kategori !== 'sjukdom' && p.kategori !== 'semester')
    .reduce((sum, p) => sum + (p.arbetstimmar || 0), 0)

  const xDagar = pass.filter(p => p.ar_x_dag)
  const skillnad = totalKravTimmar - ordinarieTid
  return { skillnad, xDagar, behovdXTid: skillnad }
}

// Formatera datum till svenska
export function formateraDatum(datum) {
  return new Date(datum).toLocaleDateString('sv-SE', {
    weekday: 'short', day: 'numeric', month: 'short'
  })
}

// Kolla om ett datum är helg
export function arHelg(datum) {
  const dag = new Date(datum).getDay()
  return dag === 0 || dag === 6
}
